import { render, staticRenderFns } from "./Fa.vue?vue&type=template&id=b13b0022&scoped=true&"
import script from "./Fa.vue?vue&type=script&lang=js&"
export * from "./Fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13b0022",
  null
  
)

export default component.exports